import {getParameterByName} from './utils'

function isNumeric(value) {
    return /^-?\d+$/.test(value);
}

export function getReportParam(store_get, report_type_name, param_name, report_url)
{
    var param = undefined;

    var store_value = store_get(report_type_name, param_name);
    if (store_value !== undefined)
    {
        param = store_value;
    }
    else
    {
        var url_value = getParameterByName(param_name, report_url);
        if (url_value !== null && url_value !== '')
        {
            param = url_value;
        }
    }

    if (param !== undefined)
    {
        if (isNumeric(param))
        {
            return parseInt(param, 10);
        }
        else
        {
            return param;
        }
    }

    return undefined;
}

export function getDescriptionFromUrl(url)
{
    if (url === "/printers")
    {
        return "Printers";
    }
    else if (url === "/printer")
    {
        return "Printer";
    }
    else if (url === "/users")
    {
        return "Users";
    }
    else if (url === "/user")
    {
        return "User";
    }
    else if (url === "/groups")
    {
        return "Groups";
    }
    else if (url === "/group")
    {
        return "Group";
    }

    return undefined;
}